








import {
  Component,
  Vue,
  Prop
} from "vue-property-decorator";
import Chart, { ChartData, ChartOptions } from "chart.js";
import moment from "moment";

import { IDailyPerformanceSummary } from "../../models/interfaces/performance/daily-performance-summary.model.interface";

// Set global chart defaults.
Chart.defaults.global.defaultFontFamily = "Poppins";
Chart.defaults.global.defaultFontColor = "#2e2e2e";
Chart.defaults.global.defaultFontSize = 16;

@Component({})
export default class DailyPerformanceChart extends Vue {
  @Prop([String])
  public chartId: string;

  @Prop([Number])
  public width: number;

  @Prop([Number])
  public height: number;

  @Prop() public chartData: IDailyPerformanceSummary;

  public chart: Chart | null = null;

  public renderChart(data: any, options: any) {
    const canvas: any = this.$refs.canvas;
    this.chart = new Chart(canvas.getContext("2d"), {
      type: "line",
      data,
      options
    });
  }

  public setupChart() {
    const dataModel: ChartData = {
      labels: this.chartData.keys.map((x) => moment(x).format("MMM DD YYYY")),
      datasets: [
        {
          label: "Loads",
          yAxisID: "left-axis",
          data: this.chartData.loads,
          backgroundColor: ["rgba(153, 102, 255, 0.2)"],
          borderColor: ["rgba(153, 102, 255, 1)"]
        },
        {
          label: "Impressions",
          yAxisID: "left-axis",
          data: this.chartData.impressions,
          backgroundColor: ["rgba(255, 159, 64, 0.2)"],
          borderColor: ["rgba(255, 159, 64, 1)"]
        },
        {
          label: "Engagements",
          yAxisID: "left-axis",
          data: this.chartData.keyPresses,
          backgroundColor: ["rgba(255, 102, 102, 0.2)"],
          borderColor: ["rgba(255, 102, 102, 1)"]
        },
        {
          label: "Clicks",
          yAxisID: "left-axis",
          data: this.chartData.clicks,
          backgroundColor: ["rgba(75, 192, 192, 0.2)"],
          borderColor: ["rgba(75, 192, 192, 1)"]
        }
      ]
    };

    const optionsModel: ChartOptions = {
      responsive: true,
      title: {
        display: true,
        text: "Daily Overview",
        fontSize: 26,
        fontFamily: "Poppins",
        fontColor: "#2e2e2e",
        fontStyle: "bold"
      },
      tooltips: {
        mode: "index",
        backgroundColor: "#ed1c3a",
        titleFontSize: 20,
        titleFontColor: "#fff",
        titleSpacing: 6,
        xPadding: 15,
        yPadding: 15,
        cornerRadius: 10,
        bodyFontSize: 16,
        bodySpacing: 6,
        displayColors: false,
        callbacks: {
          label(tooltipItem, chart) {
            const datasetIndex = tooltipItem.datasetIndex || 0;
            const datasetLabel = chart.datasets![datasetIndex].label || "";

            return (
              datasetLabel + ": " + Number(tooltipItem.yLabel).toLocaleString()
            );
          }
        }
      },
      scales: {
        yAxes: [
          {
            type: "linear",
            display: true,
            position: "left",
            id: "left-axis",
            ticks: {
              callback(value: number, index, values) {
                return value.toLocaleString();
              }
            }
          }
        ]
      }
    };

    this.renderChart(dataModel, optionsModel);
  }

  public mounted() {
    this.setupChart();
  }

  public beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
}
